import React from "react";

const ResumeCard1 = ({ title, subtitle, des }) => {
    return (
        <div className="w-full h-full group flex">
            <div className="w-10 h-[6px] bgOpacity mt-16 relative">
                <span className="absolute w-5 h-5 rounded-full -top-2 -left-3 flex justify-center items-center bg-black bg-opacity-60">
                    <span className="w-3 h-3 rounded-full bg-bodyColor inline-flex group-hover:bg-designColor duration-300"></span>
                </span>
            </div>

            <div className="w-full bg-black bg-opacity-20 hover:bg-opacity-30 duration-300 rounded-lg px-10 flex flex-col justify-center gap-6 sm:gap-10 shadow-shadowOne">
                <div>
                    <h3 className="text-base sm:text-lg font-semibold group-hover:text-white duration-300">{title}</h3>
                    <p className="text-sm sm:text-base mt-2 text-gray-400 group-hover:text-white duration-300">{subtitle}</p>
                    <p className="text-sm sm:text-base mt-2 text-gray-400 group-hover:text-white duration-300">{des}</p>
                </div>
            </div>
        </div>
    );
}

export default ResumeCard1;
